import React from "react";
import styled, { keyframes } from "styled-components";
import { color, shadow, space } from "styled-system";

const floating = keyframes` 
  0% { transform: translate(0,  0px); opacity: 1;} 
  50%  { transform: translate(0, 5px); opacity: 1;} 
  100%   { transform: translate(0, -0px); opacity: 1; }     
`;

const stopFloating = keyframes` 
  0% { transform: translate(0,  -0px); opacity: 1;} 
  100%   { transform: translate(0, -0px); opacity: 1; }     
`;

const Style = styled.button`
  width: 100%;
  height: 50px;
  @media ${"only screen and (min-width: 768px)"} {
    height: 60px;
  }
  @media ${"only screen and (min-width: 1024px)"} {
    height: 70px;
  }
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  transition: background-color 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  overflow: hidden;
  animation: ${stopFloating} 1s linear;
  animation-fill-mode: forwards;
  ${color};
  ${shadow};
  ${space};
  &:hover {
    /* opacity: 1; */
    animation-name: ${floating};
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-play-state: running; /* play the animation  */
  }
`;

const Child = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const Button = (props) => {
  const { children, ...other } = props;

  return (
    <Style type="button" {...other}>
      <Child>{children}</Child>
    </Style>
  );
};
